import {request} from "../axios/index";

let funs = {
	postcardList: data => request({url: 'admin/getPostcardList', method: 'post', data}),//明信片
	addPostcard: data => request({url: 'admin/addPostcard', method: 'post', data}),//添加明信片
	updatePostcard: data => request({url: 'admin/updatePostcard', method: 'post', data}),//修改明信片
	deletePostcard: data => request({url: 'admin/deletePostcard', method: 'post', data}),//删除明信片
	getExpress: data => request({url: 'admin/getPostcardExpress', method: 'post', data}),//查询运费
	updateExpress: data => request({url: 'admin/updatePostcardExpress', method: 'post', data}),//修改运费
	wxQrCode: data => request({url: 'admin/getPostcardQrCode', method: 'post', data}),//小程序二维码
	postcardOrderList: data => request({url: 'admin/getPostcardOrderList', method: 'post', data}),//明信片订单列表
	addPostcardExpress: data => request({url: 'admin/addPostcardReceiveExpress', method: 'post', data}),//明信片添加物流
	getPostcardExpress: data => request({url: 'admin/getPostcardReceiveExpress', method: 'post', data}),//明信片擦查询物流
	postcardPhoto: data => request({url: 'admin/getPostcardOrderPhoto', method: 'post', data}),//明信片订单图片
	postcardOrderCount: data => request({url: 'admin/getPostcardOrderCount', method: 'post', data}),//明信片订单统计
	/*短信*/
	smsOrderList: data => request({url: 'admin/smsOrderList', method: 'post', data}),//短信订单记录
	getSms: data => request({url: 'admin/smsMargin', method: 'post', data}),//短信余量
	smsSendList: data => request({url: 'admin/smsSendList', method: 'post', data}),//短信发送记录
	smsPay: data => request({url: 'admin/servicePay', method: 'post', data}),//短信支付
	smsQrCode: data => request({url: 'admin/smsQrCode', method: 'post', data}),//短信支付二维码
	smsOrderStatus: data => request({url: 'admin/smsOrderStatus', method: 'post', data}),//短信购买状态回调
	scenicArea: data => request({url: 'admin/getScenicArea', method: 'post', data:{ pageindex: 1, pagesize: 1000}}),//景区
}

export default funs;




// WEBPACK FOOTER //
// ./src/api/card.js